<script>
	import Icon from "../../library/Icon.svelte";

	export let api;

	function handleUndo() {
		api.getStores().state.undo();
	}

	$: state = api.getReactiveState();
	$: history = state.historyState;
	$: activeProject = state.activeProject;
	$: historyState = state.historyState;

	let canUndo;
	$: {
		const log = $history.undo?.filter(u => {
			if (typeof u === "object") {
				return (
					u.branchId === "$allBranches" ||
					u.branchId === $activeProject
				);
			}
			const batches = $historyState.batches[u][0];
			return (
				batches.branchId === "$allBranches" ||
				batches.branchId === $activeProject
			);
		});
		canUndo = log.length > 0;
	}

</script>

<div class="wx-todo_undo">
	<Icon on:click={handleUndo} name={'undo'} disabled={!canUndo} clickable />
</div>

<style>
	.wx-todo_undo {
		margin-right: 12px;
	}

</style>
